import { type ReactNode, useId } from 'react';
import { ButtonUI, type ButtonUIProps } from 'sonata-react-components';

import './entityTabEmptyState.scss';

type Props = {
  buttonProps: Pick<ButtonUIProps, 'onClick' | 'text'> & Partial<Omit<ButtonUIProps, 'onClick' | 'text'>>;
  description: ReactNode;
  title: ReactNode;
};

export default function EntityTabEmptyState({ buttonProps, description, title }: Readonly<Props>) {
  const buttonId = useId();

  const resolvedButtonProps: ButtonUIProps = {
    icon: 'fal fa-plus',
    id: buttonId,
    shape: 'squareRounded',
    size: 'medium',
    type: 'primary',
    visible: true,
    ...buttonProps
  };

  return (
    <div className="entityTabEmptyState">
      <i className="entityTabEmptyState__mainIcon fa-regular fa-bolt" />
      <h3 className="entityTabEmptyState__title">{title}</h3>
      <h4 className="entityTabEmptyState__description">{description}</h4>
      <div className="entityTabEmptyState__action">
        <ButtonUI {...resolvedButtonProps} />
      </div>
    </div>
  );
}
